import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactGA from "react-ga4";

ReactGA.initialize("G-N15VLDCW9G");

// Send pageview with a custom path
ReactGA.send({ hitType: "pageview", page: "/portfolio", title: "Portfolio Page" });
ReactGA.send({ hitType: "pageview", page: "/", title: "Home Page" });

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
